// extracted by mini-css-extract-plugin
export default {"logsContainer":"CourseLogs_logsContainer__wn0z1"};